import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdsReportTypes = reportTypes => ({
  type: actionTypes.SET_ADS_REPORT_TYPES,
  payload: reportTypes
})
